import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { geometryTypeSet, geometryTypeSelector } from 'redux/keyFieldsSlice';

import { FormControl } from 'components/StyledComponents';

import Select from 'components/Select';
import { CalciteLabel, CalciteOption } from 'components/Calcite';

type GeometryTypeSelectProps = {
  hasNone?: boolean;
};

const GeometryTypeSelect: React.FC<GeometryTypeSelectProps> = ({ hasNone }) => {
  const dispatch = useDispatch();
  const geometryType = useSelector(geometryTypeSelector);
  const selectedValue = hasNone && !geometryType ? '__NONE__' : geometryType;

  const items = useMemo(() => {
    const menuItems = [
      <CalciteOption
        key="envelope"
        selected={selectedValue === 'esriGeometryEnvelope'}
        value="esriGeometryEnvelope"
      >
        Envelope
      </CalciteOption>,
      <CalciteOption
        key="multipoint"
        selected={selectedValue === 'esriGeometryMultipoint'}
        value="esriGeometryMultipoint"
      >
        Multipoint
      </CalciteOption>,
      <CalciteOption
        key="point"
        selected={selectedValue === 'esriGeometryPoint'}
        value="esriGeometryPoint"
      >
        Point
      </CalciteOption>,
      <CalciteOption
        key="polygon"
        selected={selectedValue === 'esriGeometryPolygon'}
        value="esriGeometryPolygon"
      >
        Polygon
      </CalciteOption>,
      <CalciteOption
        key="polyline"
        selected={selectedValue === 'esriGeometryPolyline'}
        value="esriGeometryPolyline"
      >
        Polyline
      </CalciteOption>
    ];

    if (!hasNone) return menuItems;

    return [
      ...menuItems,
      <CalciteOption
        key="__NONE__"
        selected={selectedValue === '__NONE__'}
        value="__NONE__"
      >
        None
      </CalciteOption>
    ];
  }, [hasNone, selectedValue]);

  return (
    <FormControl>
      <CalciteLabel>Geometry Type</CalciteLabel>
      <Select
        label="Geometry Type"
        value={selectedValue}
        options={items}
        onChange={value => dispatch(geometryTypeSet(value as GeometryType))}
      />
    </FormControl>
  );
};

export default GeometryTypeSelect;
